import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, GetMethodResponse, ListMethodArg, ListMethodResponse, ModelClass, References } from '/imports/types';
import { validateBoolean, validateString } from '/imports/validators';
import { EgaugeConfig } from '/server/integrations/egauge';

export interface EgaugeMeter extends Doc, EgaugeConfig {
  meterId: string;
}
export type Model = EgaugeMeter;

export const EgaugeMeters = new Mongo.Collection<EgaugeMeter>('egaugeMeters');

type Refs = References<Model>

export const modelClass: ModelClass<Model, Refs> = {
  collection: EgaugeMeters,
  editableFields: ['active', 'meterId', 'domain', 'username', 'password', 'idx'],
  fieldLimits: {
    'domain': 256, 'idx': 128, 'meterId': 64, 'password': 4096, 'username': 256,
  },
  listMethod: DeclareMethod<ListMethodArg<EgaugeMeter>, ListMethodResponse<EgaugeMeter, Refs>>('listEgaugeMeters'),
  getMethod: DeclareMethod<string, GetMethodResponse<EgaugeMeter, Refs>>('getEgaugeMeter'),
  createMethod: DeclareMethod<Partial<EgaugeMeter>, string>('createEgaugeMeter'),
  updateMethod: DeclareMethod<Partial<EgaugeMeter>, string>('updateEgaugeMeter'),
  deleteMethod: DeclareMethod<string>('deleteEgaugeMeter'),
  pathPrefix: '/production-meters',
  asString: (document) => document.name || document.apiKey || document._id,
  modelName: 'EGauge',
  pluralName: 'EGauges',
  searchQuery: (search?: string) => {
    search = search?.trim();
    if (!search?.length) return {};
    return {
      $or: [
        { _id: search },
        { name: new RegExp(search, 'gi') },
        { identifier: new RegExp(search, 'gi') },
      ]
    };
  },
  validate: async (document: Partial<EgaugeMeter>) => {
    const errors: { [key: string]: string[] } = {};
    validateBoolean(errors, document, 'active');
    validateString(errors, document, 'meterId', { required: true });
    validateString(errors, document, 'domain', { required: true });
    return errors;
  },
};

export const getEgaugeRegisters = DeclareMethod<Omit<EgaugeConfig, '_id' | 'idx'>, any>('ds.getEgaugeRegisters');
// export const addEgaugeMeter = DeclareMethod<Omit<EgaugeConfig, '_id'>, string>('ds.addEgaugeMeter');
export const pullEgaugeMeterData = DeclareMethod<{ _id: string, days?: number }>('ds.pullEgaugeMeterData');

Meteor.isServer && Meteor.startup(async () => {
  await EgaugeMeters.createIndexAsync({ meterId: 1 });
  await EgaugeMeters.createIndexAsync({ domain: 1 });
});